import { loadConfig as baseLoadConfig } from 'c12'
import type { FastStoreConfig } from './generated-types'

const CONFIG_FILE_NAME = 'faststore'

/**
 * Loads an fsp configuration file with the given name
 * @param configFileName Name of the config file @default 'fsp'
 * @returns
 */
export async function loadConfig(
  configFileName: string = CONFIG_FILE_NAME
): Promise<FastStoreConfig> {
  const { config } = await baseLoadConfig<FastStoreConfig>({
    configFile: configFileName,
  })

  return config
}
